import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as entryMetaTransformer } from "./EntryMeta";
import { transform as channelTransformer } from "./Channel";
import { fromSqlDateTime } from "../helpers/Date";

export const ChannelValidationSchema = Yup.object().shape({});

export const EntryObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    title: null,
    slug: null,
    description: null,
    hidden: null,
    channel_id: null,
    can_sync: null,
    created_at: null,
    modified_at: null,
    sort_order: [],
    meta: [],
    channel: {},
};

/**
 * Transform API object to a Entry object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let entry = Object.assign({}, EntryObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        title: requestData.title,
        slug: requestData.slug,
        description: requestData.description,
        hidden: requestData.hidden,
        channel_id: forceInt(requestData.channel_id),
        can_sync: requestData.can_sync,
        sort_order: requestData.sort_order,
        created_at: fromSqlDateTime(requestData.created_at),
        modified_at: fromSqlDateTime(requestData.modified_at),
        object_type: "entry",
    });

    if (requestData.meta) {
        let meta = entryMetaTransformer(requestData.meta);
        entry = Object.assign({}, entry, { meta: meta });
    }
    if (requestData.channel) {
        let channel = channelTransformer(requestData.channel);
        entry = Object.assign({}, entry, { channel: channel });
    }

    return entry;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            object_type: undefined,
        },
        resetVars
    );
}
